const func = $target => {
	window.loader.key('maps', function() {
		var $map = $target.find('.map');

		var map = new google.maps.Map($map[0], {
			center: {
				lat: Number($map.data('lat')),
				lng: Number($map.data('lng'))
			},
			zoom: Number($map.data('zoom'))
		});

		// Display the marker
		var marker = new google.maps.Marker({
			position: {
				lat: Number($map.data('lat')),
				lng: Number($map.data('lng'))
			},
			// A custom icon can be defined here, if desired
			// icon: '/path/to/custom/icon.png',
			map: map
		});
	});
};

export default func;
